<template>
  <div class="practiceAreas">
    <div class="section is-medium">
      <div class="container is-fluid">
        <div class="columns">
          <div class="column is-one-quarter">
            <h1 class="deneme">FAALİYET ALANLARI</h1>
          </div>
          <div class="tile is-ancestor">
            <span class="plusActive"></span>
            <div class="tile is-vertical is-12">
              <div class="tile">
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification ">
                    <ul class="tile is-parent is-vertical">
                      <li>Fikri ve Sınai Mülkiyet Hukuku</li>
                      <li>Bilgi Teknolojileri, E-Ticaret</li>
                      <li>Alan Adları ve Telekomünikasyon</li>
                      <li>Kişisel Verilerin Korunması</li>
                    </ul>
                  </article>
                </div>
                <div class="tile is-parent">
                  <article class="tile is-child notification">
                    <ul class="has-text-right is-parent is-vertical tile">
                      <li>Deniz ve Taşıma Hukuku</li>
                      <li>Hava Hukuku</li>
                      <li>Gümrük ve Liman İşletmeleri</li>
                      <li>Yabancıların Çalışma ve İkamet İzinleri</li>
                    </ul>
                  </article>
                </div>
              </div>
              <div class="tile">
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <ul class="has-text-left is-parent is-vertical tile">
                      <li>Dava Takibi ve Ticari Uyuşmazlıklar</li>
                      <li>Sözleşmeler</li>
                      <li>Gayrimenkul Hukuku</li>
                      <li>İnşaat Hukuku</li>
                    </ul>
                  </article>
                </div>
                <div class="tile is-parent">
                  <article class="tile is-child notification">
                    <ul class="has-text-right is-parent is-vertical tile">
                      <li>Yeni Girişimler (Start-Up) ve Uluslararası Yatırımlar</li>
                      <li>İzin, Lisans ve Ruhsatlandırma</li>
                      <li>Medya, Eğlence ve Moda Hukuku</li>
                      <li>Spor Hukuku</li>
                    </ul>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'practiceAreas',
    data() {
      return {

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .practiceAreas p {
    font-size: 1.5rem;
  }

  #app {
    background: #606c96;
  }

  .practiceAreas h1::after {
    content: "";
    position: absolute;
    height: 5px;
    bottom: 0;
    left: 0;
    width: 40%;
    background: #81A716;
  }

  .practiceAreas h1 {
    position: relative;
    color: #504f50;
    font-family: 'SEC', sans-serif;
  }

  .iceriks {
    background: url(/static/sarikayaPlus.svg) no-repeat center center;
  }

  .tile.is-parent ul {
    display: flex;
    justify-content: center;
  }

  .tile.is-parent {
    min-height: 230px;
  }

  .plusActive {
    background: #81a716;
    height: 200px;
    width: 200px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: -1;
  }

  .tile.is-ancestor:last-child {
    position: relative;
  }

  ul.tile.is-parent.is-vertical {
    font-size: 1.3rem;
  }


  @media only screen and (max-width: 768px) {
    .practiceAreas {
      margin-bottom: 100px;
    }
    .practiceAreas h1 {
      font-size: 25px;
    }
    div.column.is-one-quarter::after {
      content: "";
      position: absolute;
      right: 12%;
      top: 0;
      height: 100%;
      background:unset;
      width: 1px;
    }
    ul li {
      text-align: left;
    }
    .plusActive {
      display: none;
    }
    .tile.is-parent {
      padding: 0px;
      min-height: 90px;
    }
  }
</style>



// WEBPACK FOOTER //
// faaliyet.vue?744e1bf4